// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GWNGW0 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  align-self: stretch;
  height: 100%;
}

.M6Po3d {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-0-5);
}

.XTVzF9 {
  align-self: stretch;
}

.fnb1cE {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-3);
  flex: 1;
}

.W4sHrJ {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-self: stretch;
  background: var(--surface-neutral-white);
  border-radius: var(--card-border-radius);
  box-shadow: var(--card-box-shadow);
  flex: 1;
}

.qPQ7HZ {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/DepositBillet/DepositBillet.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,kCAAkC;EAClC,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;AACT","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  align-self: stretch;\n  height: 100%;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-0-5);\n}\n\n.breadcrumb {\n  align-self: stretch;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  flex: 1;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  align-self: stretch;\n  background: var(--surface-neutral-white);\n  border-radius: var(--card-border-radius);\n  box-shadow: var(--card-box-shadow);\n  flex: 1;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GWNGW0`,
	"header": `M6Po3d`,
	"breadcrumb": `XTVzF9`,
	"content": `fnb1cE`,
	"card": `W4sHrJ`,
	"stepContent": `qPQ7HZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
